import { Wrap, PlaceholdedInput, RightAdorn } from './styles';

/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useRef, useState, useEffect } from 'react';

/**
 * Input para utilização com formik
 * o name e o id são atribuídos pelo prop name
 */
/**
 * TextInput
 * 
 * @param {*} formik
 * @param {string} label
 * @param {string} name
 * @param {string} fixedPlaceholder
 * @param {boolean} rightAdorn
 * @param {number} width
 * @param {*} props Resto
 * @returns 
 */
const TextInput = ({
  formik,
  label,
  name,
  fixedPlaceholder,
  rightAdorn,
  width,
  ...props
}) => {
  TextInput.propTypes = {
    /** Objeto Formik criado pelo hook useFormik */
    formik: PropTypes.object.isRequired,
    /** label do input */
    label: PropTypes.string,
    /** Conteúdo do placeholder/label que aparece na esquerda */
    fixedPlaceholder: PropTypes.string,
    /** name e id do input */
    name: PropTypes.string.isRequired,
  };
  /**
   * Essa é a referência para o label que é utilizado
   * apenas na variante de componente que tem um comple-
   * mento de placeholder que funciona como um label
   * interno à esquerda como o input de "Complemento de
   * endereço" no step de Detalhes da criação de módulos
   */
  const PHlabel = useRef(null);
  const [PHlabelWidth, setPHlabelWidth] = useState(10);
  useEffect(() => {
    if (PHlabel.current) setPHlabelWidth(PHlabel.current.offsetWidth);
  }, [PHlabelWidth]);

  return (
    <Wrap rightAdorn={rightAdorn} className="wrap" width={width}>
      {label ? <label htmlFor={name}>{label}</label> : null}
      {fixedPlaceholder ? (
        <PlaceholdedInput labelWidth={PHlabelWidth} rightAdorn={rightAdorn}>
          <label ref={PHlabel} htmlFor={name}>
            {fixedPlaceholder}
          </label>
          <input
            id={name}
            {...props}
            {...formik.getFieldProps(name)}
            className={
              formik.touched[name] && formik.errors[name] ? 'invalid' : ''
            }
          />
        </PlaceholdedInput>
      ) : props.type !== 'multiline' ? (
        <input
          id={name}
          {...props}
          {...formik.getFieldProps(name)}
          className={
            formik.touched[name] && formik.errors[name] ? 'invalid' : ''
          }
        />
      ) : (
        <textarea
          id={name}
          {...props}
          {...formik.getFieldProps(name)}
          className={
            formik.touched[name] && formik.errors[name] ? 'invalid' : ''
          }
        />
      )}
      {rightAdorn && <RightAdorn>{rightAdorn}</RightAdorn>}
      {formik.touched[name] && formik.errors[name] ? (
        <div className="error">{formik.errors[name]}</div>
      ) : null}
    </Wrap>
  );
};

export default TextInput;
